/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowNatureWalkTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowNatureWalk,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Explore the Outdoors!",
    "Nature Awaits!",
    "Let’s Take a Walk!",
  ],
  title: "Nature Walk",
  description: "Organize a refreshing nature walk.",
  longDescription:
    "Gather your friends for a peaceful nature walk! Choose a date, decide on a location, and plan activities along the way!",
  emoji: "🌳",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Travel,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Nature Walk",
          emoji: "🌳",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we go on the nature walk?",
          emoji: "📅",
          completeAction: {
            question: "Decide on a location?",
            description: "Where do we want to walk?",
            addModules: [
              {
                type: ModuleType.Location,
                doneType: ModuleDoneType.Voting,
                title: "What locations should we consider?",
                emoji: "🌲",
                completeAction: {
                  question: "Decide on activities during the walk?",
                  description: "What activities should we do while walking?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What activities should we plan?",
                      emoji: "🚶",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Enjoy the Great Outdoors!",
    outroDescription: "Your nature walk plans are set! Enjoy the fresh air!",
  },
};
